window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('form[data-submit-once]').length) {
    import('./_form-submit-once.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
